<div class="image-container">
    <img [src]="image.imgURL | srcSanitizer" class="img-responsive" alt="{{ image.label }}">
</div>
